<template>
    <div class="h-20 bg-white p-3 flex-grow fixed top-0 right-0" :class="expand?'left-64':'left-0 sm:left-16'">      
        <span class="font-bold text-4xl align-middle inline-block bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent h-[1.3em] mt-1">{{ title }}</span>
        <span v-if="user.mail" class="float-right hidden whitespace-nowrap text-xl mt-3 font-bold sm:inline-block">Willkommen, {{ user.mail }}</span>
        <font-awesome-icon icon="bars" class="float-right inline-block sm:hidden text-3xl text-primary cursor-pointer mt-1" @click="$emit('toggleMenu')"/>
    </div>
</template>
  
<script>
// @ is an alias to /src
export default {
    name: 'Header',
    props: ['title', 'user','expand'],

}
</script>
  